import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from 'src/app/utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class DistrictMaintenanceService {

  constructor(
    private http: HttpService,
  ) { }
  
  getList(data?: any) {
    return this.http.post(Path.DISTRICT.GET_LIST, data);
  }
  
  getDetail(params?: any) {
    return this.http.get(Path.DISTRICT.GET_DETAIL, params);
  }
    
  insert(data?: any) {
    return this.http.post(Path.DISTRICT.INSERT, data);
  }

  genericMaintenanceDownload(data?: any) {
    return this.http.post(Path.DOWNLOAD.DOWNLOAD_DISTRICT_MAINTENACE, data);
  }
}